import React from 'react';
import { Dialog, DialogContent } from './ui/dialog';
import EstimateForm from './EstimateForm';

const EstimateModal = ({ open, onOpenChange }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[600px] max-h-[90vh] overflow-y-auto p-6">
        <EstimateForm isModal={true} onClose={() => onOpenChange(false)} />
      </DialogContent>
    </Dialog>
  );
};

export default EstimateModal;
